import React from 'react';
import { PillButton } from './style';

/** Pill button. variant: primary | secondary | ghost | danger; size: default | small. */
const Pill = React.forwardRef(function Pill(
  { variant = 'primary', size = 'default', type = 'button', children, ...rest },
  ref
) {
  return (
    <PillButton ref={ref} type={type} $variant={variant} $size={size} {...rest}>
      {children}
    </PillButton>
  );
});

export default Pill;
